<template>
    <div>
        <label for="" v-if="!!label"
            >{{ label }}
            <span v-if="required" class="required-field-mark">*</span></label
        >
        <b-form-timepicker
            v-bind="$attrs"
            v-on="$listeners"
        ></b-form-timepicker>
    </div>
</template>
<script>
export default {
    inheritAttrs: false,
    props: {
        label: {
            type: String,
            default: '',
        },
        required: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
